export const environment = {
	production: false,
	apiUrl: 'http://localhost:8080'
};



// WEBPACK FOOTER //
// ./src/environments/environment.dev.ts